import request from '@/utils/request'
import qs from 'qs'

// 主任页

// ############# 信息中心工单统计

// 统计头
export function getSystemStatistics (params) {
  return request.get('/boss/system-statistics', { params })
}

// 表格
export function getTicketList (params) {
  return request.get('/boss/data-category', { params })
}

// 趋势图
export function getTicketTrend (params) {
  return request.get('/boss/monthly-statistics', { params })
}

// 导出
export function exportTable (params) {
  return request.get('/boss/data-category-export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

// ############# 业务建设监控

// 接入情况
export function getAccessStatus (params) {
  return request.get('/boss/service-access-status', { params })
}

// 接入表格
export function getServiceAccessList (params) {
  return request.get('/boss/service-access-table', { params })
}

// 接入表格-某条记录详情
export function getServiceAccess (id) {
  return request.get(`/boss/service-debt/${id}`)
}

// 接入表格-某条记录更新
export function updateServiceAccess (id, data) {
  return request.put(`/boss/service-access/${id}`, data)
}

// 接入表格-导出
export function exportServiceAccess (params) {
  return request.get('/boss/service-access-table-export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

// ############# 业务真实访问和资源使用

// 统计头状态
export function getServiceResourceStatus (params) {
  return request.get('/boss/service-resource-status', { params })
}

// 设备繁忙top
export function getDeviceBusyTop (params) {
  return request.get('/boss/service-device-busy-top', { params })
}

// 设备空闲top
export function getDeviceIdleTop (params) {
  return request.get('/boss/service-device-idle-top', { params })
}

// 请求数bottom
export function getDeviceRequestBottom (params) {
  return request.get('/boss/service-device-request-bottom', { params })
}

// 数据表格
export function getServiceResource (params) {
  return request.get('/boss/service-resource-table', { params })
}

// 导出
export function exportServiceResource (params) {
  return request.get('/boss/service-resource-table-export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

// ############# 业务问题处理情况

// 告警情况
export function getServiceAlertStatus (params) {
  return request.get('/boss/service-alert-status', { params })
}

// 事件情况
export function getServiceAlertEvents (params) {
  return request.get('/boss/service-alert-events', { params })
}

// 历史告警数top
export function getHistoryAlertTop (params) {
  return request.get('/boss/service-history-alert-top', { params })
}

// 重要告警解决率bottom
export function getAlertSolvedBottom (params) {
  return request.get('/boss/service-critical-alert-solved-bottom', { params })
}

// 数据表格
export function getServiceAlert (params) {
  return request.get('/boss/service-alert-table', { params })
}

// 导出
export function exportServiceAlertTable (params) {
  return request.get('/boss/service-alert-table-export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

// ############# 工单闭环情况

// 工单情况
export function getServiceStatus (params) {
  return request.get('/boss/service-status', { params })
}

// 工单平均关闭时效top3
export function getServiceTicketTop (params) {
  return request.get('/boss/service-ticket-top', { params })
}

// 工单闭环率Bottom3
export function getServiceTicketBottom (params) {
  return request.get('/boss/service-ticket-bottom', { params })
}

// 数据表格
export function getServiceData (params) {
  return request.get('/boss/service-data', { params })
}

// 导出
export function exportServiceData (params) {
  return request.get('/boss/service-data-export', {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}
